var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_679)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0712891 14.3571C0.0712891 6.42791 6.4992 0 14.4285 0C22.3577 0 28.7856 6.42791 28.7856 14.3571C28.7856 22.2864 22.3577 28.7143 14.4285 28.7143C6.4992 28.7143 0.0712891 22.2864 0.0712891 14.3571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1581 10.1846C20.6522 10.404 20.1173 10.5491 19.5698 10.6153C20.1474 10.2702 20.5802 9.72746 20.7879 9.08759C20.2452 9.41067 19.6511 9.63829 19.0314 9.76058C18.6172 9.31141 18.0657 9.01241 17.4632 8.91049C16.8608 8.80857 16.2416 8.90949 15.7027 9.19741C15.1638 9.48534 14.7357 9.94399 14.4855 10.5014C14.2354 11.0589 14.1773 11.6836 14.3205 12.2776C13.2231 12.2221 12.1497 11.9363 11.17 11.4389C10.1903 10.9415 9.32611 10.2436 8.6337 9.39043C8.39084 9.81453 8.26323 10.2948 8.26356 10.7835C8.2627 11.2374 8.37407 11.6844 8.58777 12.0848C8.80147 12.4852 9.11086 12.8265 9.4884 13.0784C9.0496 13.0665 8.62017 12.9487 8.23664 12.7352V12.7688C8.23993 13.4048 8.46276 14.02 8.86744 14.5105C9.27212 15.0011 9.83382 15.3367 10.4575 15.4608C10.2174 15.5339 9.96816 15.5724 9.71722 15.5752C9.54351 15.5732 9.37024 15.5574 9.19901 15.5281C9.37662 16.0751 9.72033 16.5532 10.1823 16.8957C10.6443 17.2383 11.2016 17.4283 11.7766 17.4394C10.8056 18.2034 9.60677 18.6204 8.37124 18.6239C8.14628 18.6246 7.9215 18.6111 7.69824 18.5835C8.95972 19.398 10.4298 19.8304 11.9314 19.8285C12.9676 19.8393 13.9955 19.6435 14.9552 19.2525C15.9149 18.8615 16.787 18.2833 17.5207 17.5515C18.2544 16.8197 18.8349 15.949 19.2283 14.9903C19.6217 14.0317 19.8202 13.0042 19.8121 11.968C19.8121 11.8536 19.8121 11.7324 19.8121 11.6113C20.3402 11.2175 20.7957 10.7347 21.1581 10.1846Z",
    fill: "#1E2132"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.628dbd3c1ef7f949b8ff21621189f803.svg";
export { ForwardRef as ReactComponent };